import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.417 10.917H5.25v-3.5h1.167zM8.75 10.917H7.583v-3.5H8.75z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.833 5.083h-1.166v7.583a1.167 1.167 0 0 1-1.167 1.167h-7a1.167 1.167 0 0 1-1.167-1.167V5.083H1.167V3.917h11.666zM3.5 12.666h7V5.083h-7z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.917 3.333H4.083V2.167h5.834z"
    }, null, -1)
  ]))]))
}
export default { render: render }